import {
    AbstractControl,
    UntypedFormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { FormControl } from './form-control.model';

export class Validator {
    name: string;
    message: string;
    fn: ValidatorFn;
}

export class FormGroupHelper {
    static checkConfirmPass: ValidatorFn = (
        group: AbstractControl
    ): ValidationErrors | null => {
        let pass = group.get('password').value;
        let confirmPass = group.get('confirmPassword').value;

        return pass === confirmPass ? null : { notSame: true };
    };

    static addServerErrors(
        formGroup: UntypedFormGroup,
        errors: { key: string; messages: string[] }[]
    ) {
        const controls = this.getControlsAsArray(formGroup);

        for (let i = 0; i < controls.length; i++) {
            const control = controls[i];
            const error = errors.find((e) => e.key === control.name);
            if (!error) control.control.cleanServerError();
            else control.control.addServerError(error.messages[0]);
        }
    }

    static cleanServerErrors(formGroup: UntypedFormGroup) {
        const controls = this.getControlsAsArray(formGroup);

        for (let i = 0; i < controls.length; i++) {
            const control = controls[i];
            control.control.cleanServerError();
        }
    }

    private static getControlsAsArray(formGroup: UntypedFormGroup) {
        return Object.keys(formGroup.controls).map((k) => {
            return {
                name: k,
                control: formGroup.controls[k] as FormControl,
            };
        });
    }

    static mapFrom(item: any, formGroup: UntypedFormGroup) {
        const controls = this.getControlsAsArray(formGroup);

        for (let i = 0; i < controls.length; i++) {
            const kvp = controls[i];

            let realItem = item;
            let propName = kvp.control.name;

            for (
                let periodIndex = propName.indexOf('.');
                periodIndex !== -1;
                periodIndex = propName.indexOf('.')
            ) {
                const prefix = propName.substring(0, periodIndex);
                realItem = realItem[prefix] || {};
                propName = propName.substring(periodIndex + 1);
            }

            if (realItem.hasOwnProperty(propName))
                kvp.control.setValue(realItem[propName]);
        }
    }

    static mapTo<TItem>(formGroup: UntypedFormGroup) {
        const result = <TItem>{};

        const controls = FormGroupHelper.getControlsAsArray(formGroup);

        for (let i = 0; i < controls.length; i++) {
            const kvp = controls[i];

            let realItem = result;
            let propName = kvp.control.name;

            for (
                let periodIndex = propName.indexOf('.');
                periodIndex !== -1;
                periodIndex = propName.indexOf('.')
            ) {
                const prefix = propName.substring(0, periodIndex);
                if (!realItem[prefix]) realItem[prefix] = {};

                realItem = realItem[prefix];
                propName = propName.substring(periodIndex + 1);
            }

            realItem[propName] = kvp.control.value;
        }

        return result;
    }
}
